// extracted by mini-css-extract-plugin
module.exports = {"header":"CountryData_header__o77gb"};